export default __webpack_public_path__ + "static/media/239bd78b-b6d3-4d67-92fb-48fe1b2acf6c.c83bd236.JPG";